import { getOptionTranslation, PresenceType } from "@keita/lanepatrol-sdk";
import { PresenceDistance } from "../../../models/HlaLane";

export const generateCraOptions = (options: string[]): SelectOption[] =>
  options.map((type) => ({
    translation: getOptionTranslation(type),
    value: type,
  }));

export const booleanOptions: SelectOption[] = [
  { value: false, translation: getOptionTranslation(PresenceType.Present) },
  { value: true, translation: getOptionTranslation(PresenceType.NotPresent) },
];

export const presenceDistanceOptions: SelectOption[] = [
  { value: null, translation: getOptionTranslation(PresenceType.NotPresent) },
  {
    value: PresenceDistance.From0to1m,
    translation: getOptionTranslation(PresenceDistance.From0to1m),
  },
  {
    value: PresenceDistance.From1to3m,
    translation: getOptionTranslation(PresenceDistance.From1to3m),
  },
];

export type SelectOption = { translation: string; value: any };
